// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__VFEJD","content":"styles_content__2WB2E","tableWrap":"styles_tableWrap__1bLoy"};